import styled from 'styled-components';
import { Loading } from '../../../../components/Loading';
import { useWebOnlineProductGroupQuery } from '../../../graphql';
import { useMenuNavigation } from '../../../hooks/useMenuNavigation';
import { CategoryCard } from '../components/CategoryCard';
import { ProductCard } from '../components/ProductCard';
import { useEffect } from 'react';

export const Menu: React.FC<{ id: string }> = ({ id }) => {
	const { selectProduct, selectProductGroup } = useMenuNavigation(id);
	const { data } = useWebOnlineProductGroupQuery({ variables: { id } });

	// fix for Median iOS where items become invisible
	useEffect(() => {
		window.scrollTo({ top: 1, behavior: 'smooth' });
	}, []);

	// if (!data) {
	// 	return <Loading />;
	// }

	// const { name, children, products } = data.onlineProductGroup;

	// this organization puts 2 views in 1 -- category view & products view.

	return (
		<>
			{data ? (
				<ProductGroupContainer>
					<Header>{data.webOnlineProductGroup.name}</Header>
					<CategoryCard
						category={data.webOnlineProductGroup.children}
						selectCategory={selectProductGroup}
					/>
					{data.webOnlineProductGroup.products.length > 0 &&
						data.webOnlineProductGroup.children.length > 0 && (
							<hr className="mb-5" />
						)}
					<ProductCard
						product_group={data.webOnlineProductGroup.name}
						products={data.webOnlineProductGroup.products}
						selectProduct={selectProduct}
					/>
				</ProductGroupContainer>
			) : (
				<Loading />
			)}
		</>
	);
};

const ProductGroupContainer = styled.div``;

const Header = styled.div`
	color: #574d45;
	font-weight: 500;
	font-size: 36px;
	text-align: center;
	padding: 24px;
`;
